import React from 'react'
import AddPlayer from './AddPlayer';

const Booking = () => {
  return (
    <div className="px-4 py-4">
      <AddPlayer/>
    </div>
  )
}

export default Booking;